import { LayoutNodeFilterType } from "@towersystems/roam-common/lib/generated-types";
import { createContext } from "react";
import Category from "../../../../utilities/data/model/Category";
import Department from "../../../../utilities/data/model/Department";
import Layout from "../../../../utilities/data/model/Layout";
import LayoutNode from "../../../../utilities/data/model/LayoutNode";
import Product from "../../../../utilities/data/model/Product";
import {
  LayoutDimensions,
  UseLayoutPagesReturn,
} from "../../../../utilities/layout";

export interface LayoutContextType {
  layout?: Layout;
  layoutNodes: LayoutNode[];
  isEditing: boolean;
  listRef: React.MutableRefObject<any>;
  pagesController: UseLayoutPagesReturn;
  layoutDimensions?: LayoutDimensions;
  getProductById: (productId: string) => Product;
  getCategoryById: (categoryId: string) => Category;
  getDepartmentById: (departmentId: string) => Department;
  getNameFromFilter: (filterType: LayoutNodeFilterType, id: string) => string;
  setWidth: (width?: number) => void;
  startEditing: () => void;
  stopEditing: () => void;
}

export const LayoutContext = createContext<LayoutContextType | undefined>(
  undefined
);
